class TabsController {
  constructor($rootScope) {
    this.tabs = [];
    this.hideMobileTabs = true;

    $rootScope.$on('OPEN_CUSTOMIZE_BUTTON', (e) => {
      this.hideMobileTabs = false;
      angular.forEach(this.tabs, tab => {
        tab.active = false;
      });
      this.tabs[0].active = true;
    });

    $rootScope.$on('OPEN_MATCH_BAR', (e) => {
      this.selectTab(this.tabs[0]);
    });

    $rootScope.$on('OPEN_INTERESTS', (e) => {
      this.selectTab(this.tabs[1]);
    });

    $rootScope.$on('OPEN_EDUCATION', (e) => {
      this.selectTab(this.tabs[2]);
    });

    $rootScope.$on('OPEN_MATCHES', (e) => {
      this.selectTab(this.tabs[3]);
    });
  }
  addTab(tab) {
    this.tabs.push(tab);
  }
  selectTab(selectedTab) {
    angular.forEach(this.tabs, tab => {
      if (!tab.active && tab === selectedTab) {
        tab.active = true;
        ga('send','event','Click','Match Toolbar',tab.tabId);
      } else {
        tab.active = false;
      }
    });
  }
  toggleMobileTabs() {
    if (this.hideMobileTabs === true) {
      this.hideMobileTabs = false;
      this.tabs[0].active = true;
      ga('send','event','Click','Match Toolbar','My Interests');
    } else {
      this.hideMobileTabs = true;
      angular.forEach(this.tabs, tab => {
        tab.active = false;
      });
    }
  }
}

TabsController.$inject = ['$rootScope'];

export default TabsController;



// WEBPACK FOOTER //
// ./src/components/tabs/tabs.controller.js